import { useState, memo } from "react";
import { Grid, Button, CircularProgress, Alert } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AssignDeliveriesModal from "../modals/Upselling/AssignDeliveriesModal";
import AssignmentResultModal from "../modals/Upselling/AssignmentResultModal";
import { usePartnerships } from "../../hooks/usePartnerships";

const UpsellDeliveries = ({
  selectedDeliveries,
  isLoading,
  error,
  refetchDeliveries,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [assignmentResult, setAssignmentResult] = useState(null);

  const {
    partnerships,
    assignDeliveries,
    loading,
    error: errorPartnership,
    success,
  } = usePartnerships();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseResultModal = () => {
    setResultModalOpen(false);
    setAssignmentResult(null);
  };

  const handleConfirmPartnershipSelection = async (partnershipId) => {
    try {
      const result = await assignDeliveries({
        orderIds: selectedDeliveries,
        partnershipId,
      });
      handleCloseModal();
      setResultModalOpen(true);
      setAssignmentResult(result);
    } catch (error) {
      console.error(
        `Error al reasignar envíos: ${modalError}, ahora se cargara error via la variable error: ${error}`
      );
      alert(`Error al reasignar envíos: ${error}`);
      handleCloseModal();
    } finally {
      refetchDeliveries();
    }
  };

  const modalLoading = isLoading || loading;
  const modalError = error || errorPartnership;
  const isButtonDisabled =
    isLoading || loading || selectedDeliveries.length === 0;

  return (
    <>
      <Grid item md={2} xs={6} mt={2}>
        <Button
          variant="outlined"
          onClick={handleOpenModal}
          disabled={isButtonDisabled}
          startIcon={
            modalLoading ? (
              <CircularProgress size={20} />
            ) : (
              <LocalShippingIcon fontSize="small" />
            )
          }
        >
          {modalLoading ? "Procesando..." : "Asignar  a partner"}
        </Button>
      </Grid>

      <AssignDeliveriesModal
        open={isModalOpen}
        onClose={handleCloseModal}
        loading={modalLoading}
        activePartnerships={partnerships}
        onConfirm={handleConfirmPartnershipSelection}
        selectedCount={selectedDeliveries.length}
      />

      <AssignmentResultModal
        open={resultModalOpen}
        onClose={handleCloseResultModal}
        result={assignmentResult}
      />
    </>
  );
};

export default memo(UpsellDeliveries);
